import {
    useState,
    forwardRef,
    useImperativeHandle,
    createRef,
    useRef,
} from 'react'
import DataElement from '../../../../Components/DataElement'
import DataList from '../../../../Components/DataList'

import SectionAccordion from '../../../IndividualCasePage/Components/SectionAccordion'

import ApplicantDataFormContext from '../../../../Contexts/ApplicantDataFormContext'

const Summary = forwardRef(({ data, showTitle = true, readOnly = true, provideData = false, backgroundRequestId, formType, autoExpand = false }, ref) => {

    const contextRef = useRef({
        backgroundRequestId,
        formType,
    })

    const [openIndex, setOpenIndex] = useState(autoExpand ? 0 : -1)

    const elementRefs = useRef(data.fields.map(_ => createRef()))

    useImperativeHandle(ref, () => ({

        validateAndGetData: () => {

            if (!provideData) {
                return {
                    isValid: true,
                    value: {
                        result: true,
                    },
                }
            }

            const elementResults = elementRefs.current.map((elementRef) => elementRef.current.validateAndGetData())

            const error = elementResults.some((result) => !result.isValid)

            const isValid = !error

            return {
                isValid,
                value: elementResults.map(element => element.value).reduce((acc, element, index) => {

                    let dataToSave = element

                    if (data.fields[index].key === "address_history") {
                        dataToSave = {
                            currentAddress: element[0],
                            addressHistory: element.slice(1),
                        }
                    }

                    acc[data.fields[index].key] = dataToSave
                    return acc
                }, {}),
            }

        },
    }))

    return (

        <ApplicantDataFormContext.Provider value={contextRef}>
            <div className='w-full' >

                {
                    showTitle && (
                        <h1 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 w-full text-center">
                            Summary
                        </h1>
                    )
                }

                {data.fields.map((formField, index) => {
                    let fieldData = data.data[formField.key]
                    if (formField.key === "address_history") {
                        const addressData = []
                        if (fieldData?.currentAddress) {
                            addressData.push(fieldData.currentAddress)
                        }
                        if (fieldData?.addressHistory) {
                            addressData.push(...fieldData.addressHistory)
                        }
                        fieldData = addressData
                    }

                    return (
                        <div key={index}>

                            <SectionAccordion
                                title={formField.title}
                                index={index}
                                openIndex={openIndex}
                                setOpenIndex={setOpenIndex}
                            >
                                {
                                    formField.arrayOf &&
                                    <DataList
                                        title={formField.title}
                                        ref={elementRefs.current[index]}
                                        attributes={formField.arrayOf.attributes}
                                        data={fieldData}
                                        readOnly={readOnly}
                                    />
                                }
                                {
                                    formField.attributes &&
                                    <DataElement
                                        ref={elementRefs.current[index]}
                                        attributes={formField.attributes}
                                        data={fieldData}
                                        readOnly={readOnly}
                                    />
                                }
                            </SectionAccordion>
                        </div>
                    )
                })}
            </div>
        </ApplicantDataFormContext.Provider>
    )

})

export default Summary
